import type { LucideIcon } from 'lucide-react';
import {
  Binoculars,
  BottleWine,
  Building2,
  Bus,
  Camera,
  CarFront,
  Compass,
  Earth,
  Flag,
  Footprints,
  Gem,
  Heart,
  Hotel,
  Luggage,
  MapPinned,
  MountainSnow,
  Palmtree,
  PlaneTakeoff,
  Rocket,
  Sailboat,
  ShipWheel,
  Snowflake,
  Sparkles,
  Star,
  Sun,
  Tent,
  TrainFront,
  Trees,
  Umbrella,
  UtensilsCrossed,
  Waves,
} from 'lucide-react';

export type TagIconId =
  | 'map-pin'
  | 'globe'
  | 'plane'
  | 'car'
  | 'train'
  | 'bus'
  | 'ship'
  | 'anchor'
  | 'palmtree'
  | 'sun'
  | 'snow'
  | 'mountain'
  | 'hike'
  | 'tent'
  | 'tree'
  | 'waves'
  | 'umbrella'
  | 'landmark'
  | 'hotel'
  | 'utensils'
  | 'wine'
  | 'camera'
  | 'compass'
  | 'binoculars'
  | 'rocket'
  | 'backpack'
  | 'sparkles'
  | 'star'
  | 'heart'
  | 'flag';

export type TagIconOption = {
  id: TagIconId;
  Icon: LucideIcon;
  labelRu: string;
  labelEn: string;
  chipClass: string;
  iconClass: string;
  fill?: boolean;
};

export const TRAVEL_TAG_ICONS: TagIconOption[] = [
  { id: 'map-pin', Icon: MapPinned, labelRu: 'Маршрут', labelEn: 'Route', chipClass: 'bg-violet-100 dark:bg-violet-950/45', iconClass: 'text-violet-700 dark:text-violet-300', fill: true },
  { id: 'globe', Icon: Earth, labelRu: 'Мир', labelEn: 'World', chipClass: 'bg-sky-100 dark:bg-sky-950/45', iconClass: 'text-sky-700 dark:text-sky-300', fill: true },
  { id: 'plane', Icon: PlaneTakeoff, labelRu: 'Авиа', labelEn: 'Flights', chipClass: 'bg-cyan-100 dark:bg-cyan-950/45', iconClass: 'text-cyan-800 dark:text-cyan-300' },
  { id: 'car', Icon: CarFront, labelRu: 'Авто', labelEn: 'Road trip', chipClass: 'bg-amber-100 dark:bg-amber-950/45', iconClass: 'text-amber-800 dark:text-amber-300' },
  { id: 'train', Icon: TrainFront, labelRu: 'Поезд', labelEn: 'Train', chipClass: 'bg-emerald-100 dark:bg-emerald-950/45', iconClass: 'text-emerald-800 dark:text-emerald-300' },
  { id: 'bus', Icon: Bus, labelRu: 'Автобус', labelEn: 'Bus', chipClass: 'bg-lime-100 dark:bg-lime-950/45', iconClass: 'text-lime-800 dark:text-lime-300' },
  { id: 'ship', Icon: Sailboat, labelRu: 'Море', labelEn: 'Sea', chipClass: 'bg-blue-100 dark:bg-blue-950/45', iconClass: 'text-blue-800 dark:text-blue-300' },
  { id: 'anchor', Icon: ShipWheel, labelRu: 'Круиз', labelEn: 'Cruise', chipClass: 'bg-indigo-100 dark:bg-indigo-950/45', iconClass: 'text-indigo-800 dark:text-indigo-300' },
  { id: 'palmtree', Icon: Palmtree, labelRu: 'Пляж', labelEn: 'Beach', chipClass: 'bg-green-100 dark:bg-green-950/45', iconClass: 'text-green-800 dark:text-green-300', fill: true },
  { id: 'sun', Icon: Sun, labelRu: 'Лето', labelEn: 'Summer', chipClass: 'bg-yellow-100 dark:bg-yellow-950/45', iconClass: 'text-yellow-800 dark:text-yellow-300', fill: true },
  { id: 'snow', Icon: Snowflake, labelRu: 'Зима', labelEn: 'Winter', chipClass: 'bg-slate-200 dark:bg-slate-800/60', iconClass: 'text-slate-700 dark:text-slate-300', fill: true },
  { id: 'mountain', Icon: MountainSnow, labelRu: 'Горы', labelEn: 'Mountains', chipClass: 'bg-stone-200 dark:bg-stone-800/60', iconClass: 'text-stone-700 dark:text-stone-300', fill: true },
  { id: 'hike', Icon: Footprints, labelRu: 'Трекинг', labelEn: 'Hiking', chipClass: 'bg-orange-100 dark:bg-orange-950/45', iconClass: 'text-orange-800 dark:text-orange-300' },
  { id: 'tent', Icon: Tent, labelRu: 'Кемпинг', labelEn: 'Camp', chipClass: 'bg-green-100 dark:bg-green-950/45', iconClass: 'text-green-800 dark:text-green-300', fill: true },
  { id: 'tree', Icon: Trees, labelRu: 'Природа', labelEn: 'Nature', chipClass: 'bg-lime-100 dark:bg-lime-950/45', iconClass: 'text-lime-800 dark:text-lime-300', fill: true },
  { id: 'waves', Icon: Waves, labelRu: 'Вода', labelEn: 'Lake & sea', chipClass: 'bg-teal-100 dark:bg-teal-950/45', iconClass: 'text-teal-800 dark:text-teal-300' },
  { id: 'umbrella', Icon: Umbrella, labelRu: 'Отдых', labelEn: 'Relax', chipClass: 'bg-sky-100 dark:bg-sky-950/45', iconClass: 'text-sky-700 dark:text-sky-300', fill: true },
  { id: 'landmark', Icon: Building2, labelRu: 'Город', labelEn: 'City', chipClass: 'bg-zinc-200 dark:bg-zinc-800/60', iconClass: 'text-zinc-700 dark:text-zinc-300' },
  { id: 'hotel', Icon: Hotel, labelRu: 'Отель', labelEn: 'Hotel', chipClass: 'bg-rose-100 dark:bg-rose-950/45', iconClass: 'text-rose-700 dark:text-rose-300' },
  { id: 'utensils', Icon: UtensilsCrossed, labelRu: 'Гастро', labelEn: 'Food', chipClass: 'bg-red-100 dark:bg-red-950/45', iconClass: 'text-red-800 dark:text-red-300' },
  { id: 'wine', Icon: BottleWine, labelRu: 'Вино', labelEn: 'Wine', chipClass: 'bg-purple-100 dark:bg-purple-950/45', iconClass: 'text-purple-800 dark:text-purple-300', fill: true },
  { id: 'camera', Icon: Camera, labelRu: 'Фото', labelEn: 'Photos', chipClass: 'bg-pink-100 dark:bg-pink-950/45', iconClass: 'text-pink-800 dark:text-pink-300' },
  { id: 'compass', Icon: Compass, labelRu: 'Приключение', labelEn: 'Adventure', chipClass: 'bg-orange-100 dark:bg-orange-950/45', iconClass: 'text-orange-800 dark:text-orange-300', fill: true },
  { id: 'binoculars', Icon: Binoculars, labelRu: 'Экскурсии', labelEn: 'Sightseeing', chipClass: 'bg-amber-100 dark:bg-amber-950/45', iconClass: 'text-amber-800 dark:text-amber-300' },
  { id: 'rocket', Icon: Rocket, labelRu: 'Эпик', labelEn: 'Epic trip', chipClass: 'bg-violet-100 dark:bg-violet-950/45', iconClass: 'text-violet-800 dark:text-violet-300', fill: true },
  { id: 'backpack', Icon: Luggage, labelRu: 'Чемодан', labelEn: 'Luggage', chipClass: 'bg-teal-100 dark:bg-teal-950/45', iconClass: 'text-teal-800 dark:text-teal-300' },
  { id: 'sparkles', Icon: Gem, labelRu: 'Особое', labelEn: 'Special', chipClass: 'bg-indigo-100 dark:bg-indigo-950/45', iconClass: 'text-indigo-800 dark:text-indigo-300', fill: true },
  { id: 'star', Icon: Star, labelRu: 'Избранное', labelEn: 'Favorite', chipClass: 'bg-yellow-100 dark:bg-yellow-950/45', iconClass: 'text-yellow-800 dark:text-yellow-300', fill: true },
  { id: 'heart', Icon: Heart, labelRu: 'Любимое', labelEn: 'Love', chipClass: 'bg-rose-100 dark:bg-rose-950/45', iconClass: 'text-rose-700 dark:text-rose-300', fill: true },
  { id: 'flag', Icon: Flag, labelRu: 'Страна', labelEn: 'Country', chipClass: 'bg-red-100 dark:bg-red-950/45', iconClass: 'text-red-800 dark:text-red-300', fill: true },
];

const STORAGE_KEY = 'mytraveldiary.tagIcons';

const iconById = new Map(TRAVEL_TAG_ICONS.map((item) => [item.id, item]));

export function getTagIconMeta(iconId: TagIconId): TagIconOption {
  return iconById.get(iconId) ?? TRAVEL_TAG_ICONS[0];
}

export function getTagIconId(tag: string | null | undefined): TagIconId {
  const key = (tag || '').trim();
  if (!key) return 'map-pin';

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const map = raw ? (JSON.parse(raw) as Record<string, TagIconId>) : {};
    const stored = map[key];
    if (stored && iconById.has(stored)) return stored;
  } catch {
    /* ignore */
  }

  return defaultIconForTag(key);
}

export function setTagIconId(tag: string, iconId: TagIconId): void {
  const key = tag.trim();
  if (!key || !iconById.has(iconId)) return;

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const map = raw ? (JSON.parse(raw) as Record<string, TagIconId>) : {};
    map[key] = iconId;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* ignore */
  }
}

export function migrateTagIcon(fromTag: string, toTag: string): void {
  const from = fromTag.trim();
  const to = toTag.trim();
  if (!from || !to || from === to) return;

  const iconId = getTagIconId(from);
  setTagIconId(to, iconId);

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    const map = JSON.parse(raw) as Record<string, TagIconId>;
    if (map[from]) {
      delete map[from];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    }
  } catch {
    /* ignore */
  }
}

export function getTagIconComponent(iconId: TagIconId): LucideIcon {
  return getTagIconMeta(iconId).Icon;
}

function defaultIconForTag(tag: string): TagIconId {
  const lower = tag.toLowerCase();

  if (/ави|flight|plane|рейс|вылет/.test(lower)) return 'plane';
  if (/авто|car|road|дорог|машин/.test(lower)) return 'car';
  if (/поезд|train|rail|жд/.test(lower)) return 'train';
  if (/автобус|bus/.test(lower)) return 'bus';
  if (/круиз|cruise|мор|sea|яхт|sail/.test(lower)) return 'ship';
  if (/гор|mount|альп|ski|лыж/.test(lower)) return 'mountain';
  if (/зим|snow|холод|фин/.test(lower)) return 'snow';
  if (/пляж|beach|sicil|итал|spain|исп|тай|bali/.test(lower)) return 'palmtree';
  if (/лет|summer|отпуск/.test(lower)) return 'sun';
  if (/город|city|weekend|уикенд/.test(lower)) return 'landmark';
  if (/отель|hotel|ноч/.test(lower)) return 'hotel';
  if (/еда|food|гастро|restaurant|кухн/.test(lower)) return 'utensils';
  if (/вино|wine/.test(lower)) return 'wine';
  if (/трек|hike|поход|trail/.test(lower)) return 'hike';
  if (/фото|photo|camera/.test(lower)) return 'camera';
  if (/люб|love|свад|honeymoon|мед/.test(lower)) return 'heart';

  return 'globe';
}
